import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProductPricesViewModel } from 'src/app/api';
import { CombinedStore } from 'src/app/core/combined.store';
import { PathType } from 'src/app/shared/enum/path-type.enum';
import { PriceService } from 'src/app/shared/services/price.service';

/**
 * Resolver de la page personnalisation.
 * Pour un parcours ESSENTIELLE avec un code partenaire (context.partnerCode), on va rechercher
 * les prix à jour (GetPrice) avant d'afficher la page.
 * Dans les autres cas, on ne fait aucun appel et on conserve les prix déjà en store.
 */
export const personnalizationPriceResolver: ResolveFn<ProductPricesViewModel | null> = () => {
  const store = inject(CombinedStore);
  const priceService = inject(PriceService);

  const isEssentielle = store.context().produit === PathType.ESSENTIELLE;
  const hasPartnerCode = !!store.context().partnerCode;

  if (!isEssentielle || !hasPartnerCode) {
    return of(null);
  }

  const couponCode = store.offer().coupon_code;
  const sponsorEmail = store.offer().sponsor_email;

  return priceService.getProductPrices(couponCode, sponsorEmail).pipe(
    catchError((err: Error) => {
      console.error('Failed to load product prices', err);
      return of(null);
    }),
  );
};
